import { ScrollView, View } from 'react-native'
import { Portal } from 'react-native-paper'

import Logo from '@/components/navigation/Logo'
import UniButton from '@/components/unistyles/UniButton'
import UniModal from '@/components/unistyles/UniModal'
import UniText from '@/components/unistyles/UniText'
import useModalStyles from '@/hooks/useModalStyles'

interface WelcomeModalProps {
  visible: boolean
  onStartTour: () => void
  onSkip: () => void
  onDismiss?: () => void
}

const WelcomeModal = ({
  visible,
  onStartTour,
  onSkip,
  onDismiss,
}: WelcomeModalProps) => {
  const { styles, getModalProps } = useModalStyles()

  return (
    <Portal>
      <UniModal
        onDismiss={onDismiss || onSkip}
        style={styles.modal}
        testID="welcome-modal"
        visible={visible}
      >
        <View style={styles.card}>
          <Logo style={styles.logo} />
          <ScrollView {...getModalProps()}>
            <UniText style={styles.title} variant="titleLarge">
              Welcome to Rescuebase!
            </UniText>
            <UniText style={styles.body} variant="bodyLarge">
              We're excited to have you here. This quick tour will guide you
              through the key features for managing fosters, adoptions, and
              volunteers. You can skip the tour at any time.
            </UniText>
          </ScrollView>
          <UniButton
            contentStyle={styles.buttonContent}
            mode="contained"
            onPress={onStartTour}
            style={styles.primaryButton}
            testID="welcome-modal-start-tour-button"
          >
            Start Tour
          </UniButton>
          <UniButton
            contentStyle={styles.buttonContent}
            mode="text"
            onPress={onSkip}
            style={styles.textButton}
            testID="welcome-modal-skip-tour-button"
          >
            Skip Tour
          </UniButton>
        </View>
      </UniModal>
    </Portal>
  )
}

export default WelcomeModal
